import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Getting Started`}</h1>
    <p><strong parentName="p"><em parentName="strong">{`TLDR: If you can write a github comment or have experience writing in markdown, you're already ahead of the game.`}</em></strong></p>
    <p>{`This project's goals are inline with providing an onramp into building websites with ease,
while also providing a base for developing more complex features into markdown focused sites, that many CMS or content/documentation heavy solutions don't allow with ease (or for free). `}</p>
    <p>{`You can start off making mdx pages in the `}<strong parentName="p">{`content`}</strong>{` folder or if you have existing `}<strong parentName="p">{`.md`}</strong>{` files you can copy
and paste them into the content folder at your own pace. `}</p>
    <p>{`It's important to know that .md files do `}<strong parentName="p">{`not`}</strong>{` allow you to write React components in them.
`}<strong parentName="p">{`Only .mdx files allow you interweave react components`}</strong></p>
    <p>{`If you'd like to learn more about writing in MDX see `}<a parentName="p" {...{
        "href": "https://mdxjs.com/getting-started"
      }}>{`their guide`}</a>{`. `}</p>
    <hr></hr>
    <h1>{`Theme-UI`}</h1>
    <p>{`This starter also makes use of `}<a parentName="p" {...{
        "href": "https://theme-ui.com/home"
      }}>{`theme-ui`}</a>{` which has some great MDX tie-ins.`}</p>
    <p>{`Specifically in this project, you'll find the `}<strong parentName="p">{`gatsby-plugin-theme-ui`}</strong>{` folder in the `}<strong parentName="p">{`src`}</strong>{` folder and the use of `}<a parentName="p" {...{
        "href": "https://dai-ui.now.sh/"
      }}>{`MakerDAO's dai-ui`}</a>{` icon package.`}</p>
    <p>{`The `}<strong parentName="p">{`index.js`}</strong>{` file hosts the theme itself, while `}<strong parentName="p">{`components.js`}</strong>{` hosts the components that can be used in your MDX files. `}</p>
    <p>{`You can find out more about the gatsby-theme-ui plugin `}<a parentName="p" {...{
        "href": "https://theme-ui.com/packages/gatsby-plugin/"
      }}>{`here`}</a>{`.`}</p>
    <hr></hr>
    <h1>{`Navigation`}</h1>
    <p>{`Lastly, this project is opinionated with some data oriented helpers in place for navigational components like Breadcrumbs, the Header, and the Sidenav. `}</p>
    <p>{`You can find more in-depth information about them on the `}<a parentName="p" {...{
        "href": "/navigation"
      }}>{`Navigation page`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      